export default "__VITE_ASSET__Bv6RQPD8__"